<mat-form-field>
  <input *ngIf="!isLongText" [(ngModel)]="question.answer!.value" [pattern]="this.regex" matInput="" [attr.inputmode]="inputMode" [attr.autocomplete]="autocomplete" placeholder="00:00" type="text" mask="Hh:m0" required="" (change)="change($event.target)" />
  <mat-error i18n="@@Checkthevalueinformed">Check the value informed</mat-error>
</mat-form-field>
